window.addEventListener('load', function() {
    if (document.location.href.indexOf('/pages/quiz-results') != -1) {
      gtag('event', 'conversion', {'send_to': 'AW-771034636/u4pfCI69sIsCEIyc1O8C'});
    } else if (document.location.href.indexOf('/pages/quiz-results-corporate') != -1) {
      gtag('event', 'conversion', {'send_to': 'AW-771034636/u4pfCI69sIsCEIyc1O8C'});
    }
});

$(window).on('load', function() {
    $('#footer .mailing-list form').submit(function(e){
    e.preventDefault();
    e.stopImmediatePropagation();
    var form = $(this);
    var formType = form.closest('.mailing-list').attr('data-form-type');
    var error = false;

    
    form.find('.error-msg').hide();
    form.find('.error').removeClass('error');

    form.find('.required').each(function(){
      if($(this).val()=="") {
        error = true;
        $(this).addClass('error');
      }
    });
    if(error){
        form.find('.error-msg').show().text('Please complete all the required fields.');
    }else{
      if(!Simplistic.validateEmail(form.find('.email').val())) {
        error = true;
        form.find('.email').addClass('error');
        form.find('.error-msg').show().text('Please provide a valid email address.');
      }
    }
    if(!error) {

    var ajaxOptions = {
        data: form.serialize(),
        url: formType === 'use_mailchimp_form' 
                ? form.attr('action') 
                : formType === 'use_klaviyo_form' 
                ? form.data('ajax-submit') 
                : form.attr('action'),
        type: 'POST'
    };
        
    if (formType === 'use_mailchimp_form') {
        ajaxOptions.dataType = 'jsonp';
    }
          
      $.ajax(ajaxOptions).done(function(data){
        if (typeof(data)=='string' && data.indexOf('property="og:title" '+'content="Challenge"')>-1) {
          form.unbind("submit");
          form.submit();
        } else {
          form.find('.form-wrap').hide();
          form.find('.success-msg').show();
        }
      }).error(function(){
        form.unbind("submit");
        form.submit();
      });
    }
  });
});
